var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MediaItemCard',{attrs:{"title":_vm.fileInfo.filename,"subtitle":_vm.subtitle,"thumbnail":_vm.thumbnail,"thumbnail-icon":_vm.fileInfo.type !== 'image',"to":_vm.to,"created-by-name":_vm.createdByName},on:{"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }